import { useEffect, useMemo, useRef, useState } from 'react';
import { EsrsReportDocsGenerator } from './DocGenerator';
import { ReportStandardPage } from './ReportStandardPage';
import { useESRSReportStructure } from './Report.hooks';
import { useParams, useSearchParams } from 'react-router-dom';
import { useCurrentCompany } from 'utils/hooks';
import { useFeatureFlags } from 'containers/Navigation';
import { useReportProgress } from './ReportProgress.hooks';
import ReportContainer from './ReportUIComponents/ReportContainer';
import ReportSideMenu from './ReportUIComponents/ReportSideMenu';

export const CreateReport = () => {
  const { esrsAssessmentId = '', framework = '' } = useParams();
  const {
    structure,
    standards,
    loading: structureLoading,
  } = useESRSReportStructure(esrsAssessmentId);
  const [searchParams] = useSearchParams();
  const urlStandardRef = useMemo(() => searchParams.get('standardRef'), [searchParams]);
  const urlStdIndex = useMemo(
    () => standards.findIndex((std) => std.reference === urlStandardRef),
    [urlStandardRef, standards]
  );
  const [standardIndex, setStandardIndex] = useState(0);
  const [selectedDr, setSelectedDr] = useState('');
  const reportRef = useRef<HTMLDivElement>(null);

  const { company } = useCurrentCompany();
  const { canDownloadEsrsReport } = useFeatureFlags({ company });

  useEffect(() => {
    if (urlStdIndex >= 0) {
      setStandardIndex(urlStdIndex);
      setSelectedDr('');
    }
  }, [urlStdIndex]);

  const progress = useReportProgress(esrsAssessmentId, framework);

  return (
    <ReportContainer
      loading={structureLoading}
      canDownloadEsrsReport={canDownloadEsrsReport}
      reportDocGenerator={<EsrsReportDocsGenerator />}
      standards={standards}
      structureLoading={structureLoading}
      standardIndex={standardIndex}
      setStandardIndex={setStandardIndex}
      sideMenu={
        <ReportSideMenu
          structure={structure}
          selectedStandard={standards?.[standardIndex]?.reference ?? ''}
          selectedStandardDRs={standards?.[standardIndex]?.disclosureRequirementRefs}
          selectedDr={selectedDr}
          isLoading={structureLoading}
          setSelectedDr={setSelectedDr}
          reportRef={reportRef}
          setSelectedStandard={(val) =>
            setStandardIndex(standards.findIndex((std) => std.reference === val))
          }
          progress={progress}
        />
      }
      reportContent={
        <ReportStandardPage
          standardIndex={standardIndex}
          setStandardIndex={setStandardIndex}
          reportRef={reportRef}
          standards={standards}
        />
      }
    />
  );
};
